import { AnalyticsInfo } from "store/adapter-config/AdapterConfigTypes";

export const SET_PERFORMANCE_REPORT_STORE_ID =
  "SET_PERFORMANCE_REPORT_STORE_ID";

export const SET_PERFORMANCE_REPORT_DATE_RANGE =
  "SET_PERFORMANCE_REPORT_DATE_RANGE";

export interface FetchPerformanceMetricsSuccessAction {
  type: typeof FETCH_PERFORMANCE_METRICS.SUCCESS;
  payload: {
    category: MetricCategory;
    currentData: any;
    comparisonData: any;
    metrics: { id: string; name: string }[];
  };
}

export const GET_REPORT_ANALYTICS_CONFIG_DETAILS = {
  SUCCESS: "GET_REPORT_ANALYTICS_CONFIG_DETAILS_SUCCESS",
  FAILURE: "GET_REPORT_ANALYTICS_CONFIG_DETAILS_FAILURE",
  REQUEST: "GET_REPORT_ANALYTICS_CONFIG_DETAILS_REQUEST",
};

export const FETCH_DATE_YEAR_METRICS = {
  SUCCESS: "FETCH_DATE_YEAR_METRICS_SUCCESS",
  FAILURE: "FETCH_DATE_YEAR_METRICS_FAILURE",
  REQUEST: "FETCH_DATE_YEAR_METRICS_REQUEST",
};

export const GET_DATE_YEAR_METRICS = "GET_DATE_YEAR_METRICS";

export const FETCH_PRODUCT_IDS_BY_ANALYTIC_IDS = {
  SUCCESS: "FETCH_PRODUCT_IDS_BY_ANALYTIC_IDS_SUCCESS",
  FAILURE: "FETCH_PRODUCT_IDS_BY_ANALYTIC_IDS_FAILURE",
  REQUEST: "FETCH_PRODUCT_IDS_BY_ANALYTIC_IDS_REQUEST",
};

export const FETCH_KPI_STORE_LIST = {
  SUCCESS: "FETCH_KPI_STORE_LIST_SUCCESS",
  FAILURE: "FETCH_KPI_STORE_LIST_FAILURE",
  REQUEST: "FETCH_KPI_STORE_LIST_REQUEST",
};

export const LOAD_KPI_STORE_LIST = "LOAD_KPI_STORE_LIST";

export type PerformanceReportActionTypes =
  | SetPerformanceReportStoreIdAction
  | SetPerformanceReportDateRangeAction
  | LoadReportAnalyticsConfigAction
  | ReportAnalyticsConfigSuccessAction
  | FetchPerformanceMetricsAction
  | FetchPerformanceMetricsSuccessAction
  | FetchPieChartDataAction
  | FetchPieChartDataSuccessAction
  | FetchPieChartDataFailureAction
  | FetchKPIProductsAction
  | FetchKPIProductsSuccessAction
  | SetKPIProductsLoadingAction
  | FetchLocationTreeDataAction
  | FetchLocationTreeDataSuccessAction
  | FetchLocationTreeDataFailureAction
  | ResetLocationTreeStateAction
  | FetchKPIAnalysisAction
  | FetchKPIAnalysisSuccessAction
  | FetchKPIAnalysisFailureAction
  | UpdateKPIProductsDetailsAction
  | LoadKPIStoreListAction
  | FetchKPIStoreListSuccessAction
  | FetchKPIStoreListFailureAction;
export interface SetPerformanceReportStoreIdAction {
  payload: SetPerformanceReportStoreIdActionPayload;
  type: typeof SET_PERFORMANCE_REPORT_STORE_ID;
}

export interface SetPerformanceReportStoreIdActionPayload {
  storeId: string;
}

export interface SetPerformanceReportDateRangeAction {
  payload: SetPerformanceReportDateRangeActionPayload;
  type: typeof SET_PERFORMANCE_REPORT_DATE_RANGE;
}

export interface SetPerformanceReportDateRangeActionPayload {
  dateRange: string;
}

export interface LoadReportAnalyticsConfigAction {
  payload: ReportAnalyticsConfigPayload;
  type: typeof GET_REPORT_ANALYTICS_CONFIG_DETAILS.REQUEST;
}

export interface ReportAnalyticsConfigPayload {
  storeId: string;
}

export interface ReportAnalyticsConfigSuccessAction {
  payload: AnalyticsInfo;
  type: typeof GET_REPORT_ANALYTICS_CONFIG_DETAILS.SUCCESS;
}

export const FETCH_PERFORMANCE_METRICS = {
  REQUEST: "FETCH_PERFORMANCE_METRICS_REQUEST",
  SUCCESS: "FETCH_PERFORMANCE_METRICS_SUCCESS",
  FAILURE: "FETCH_PERFORMANCE_METRICS_FAILURE",
};

export const FETCH_KPIS_PIE_CHART = {
  REQUEST: "FETCH_KPIS_PIE_CHART_REQUEST",
  SUCCESS: "FETCH_KPIS_PIE_CHART_SUCCESS",
  FAILURE: "FETCH_KPIS_PIE_CHART_FAILURE",
};

export const FETCH_KPI_PRODUCTS = {
  REQUEST: "FETCH_KPI_PRODUCTS_REQUEST",
  SUCCESS: "FETCH_KPI_PRODUCTS_SUCCESS",
  FAILURE: "FETCH_KPI_PRODUCTS_FAILURE",
};

export const SET_KPI_PRODUCTS_LOADING = "SET_KPI_PRODUCTS_LOADING";

export const UPDATE_KPI_PRODUCTS_DETAILS = "UPDATE_KPI_PRODUCTS_DETAILS";

export interface SetKPIProductsLoadingAction {
  type: typeof SET_KPI_PRODUCTS_LOADING;
}

export interface FetchKPIProductsSuccessAction {
  type: typeof FETCH_KPI_PRODUCTS.SUCCESS;
  payload: PieChartApiResponse;
}

export interface FetchPerformanceMetricsAction {
  type: typeof FETCH_PERFORMANCE_METRICS.REQUEST;
  payload: FetchPerformanceMetricsPayload;
}

export enum MetricCategory {
  TRAFFIC = "traffic",
  PRODUCT = "product",
  CONVERSION = "conversion",
  REVENUE = "revenue",
}

export enum PieChartType {
  TRAFFIC_BY_SOURCE = "channelGroup",
  TRAFFIC_BY_DEVICE = "deviceCategory",
  ORDERS_BY_SOURCE = "ordersSourceGroup",
  ORDERS_BY_DEVICE = "ordersDeviceCategory",
}

export interface FetchPerformanceMetricsAction {
  type: typeof FETCH_PERFORMANCE_METRICS.REQUEST;
  payload: FetchPerformanceMetricsPayload;
}

export interface FetchDateYearMetricsAction {
  type: typeof FETCH_DATE_YEAR_METRICS.REQUEST;
  payload: FetchDateYearMetricsPayload;
}

export interface FetchPerformanceMetricsPayload {
  storeId: string;
  category: MetricCategory;
  dateRange: {
    startDate: string;
    endDate: string;
  };
  comparisonDateRange: {
    startDate: string;
    endDate: string;
  };
  metrics: {
    id: string;
    name: string;
  }[];
}

export interface FetchDateYearMetricsPayload {
  storeId: string;
  dateRange: {
    startDate: string;
    endDate: string;
  };
  dimension: {
    id: string;
  };
  metrics: {
    id: string;
  }[];
  limit?: number;
}

export interface MetricValue {
  current: number;
  previous: number;
  percentageChange: number;
  polarity: "positive" | "negative";
}

export interface PerformanceMetricsResponse {
  category: MetricCategory;
  metrics: Record<string, MetricValue>;
  isLoading: boolean;
}

export interface FetchPieChartDataAction {
  type: typeof FETCH_KPIS_PIE_CHART.REQUEST;
  payload: FetchPieChartDataPayload;
}

export interface FetchPieChartDataPayload {
  storeId: string;
  chartType?: PieChartType;
  metricId?: string;
  dateRange: {
    startDate: string;
    endDate: string;
  };
  dimension: {
    id: string;
  };
  metrics: {
    id: string;
  }[];
  sortBy: {
    metricId: string;
    desc: boolean;
  };
  limit?: number;
}

export interface FetchPieChartDataSuccessAction {
  type: typeof FETCH_KPIS_PIE_CHART.SUCCESS;
  payload: PieChartApiResponse & FetchPieChartDataPayload;
  endpoint: string;
  meta?: any;
}

export interface FetchPieChartDataFailureAction {
  type: typeof FETCH_KPIS_PIE_CHART.FAILURE;
  payload: {
    chartType?: PieChartType;
    metricId?: string;
    error: string;
  };
}

export interface PieChartApiResponse {
  dimensionHeader: {
    id: string;
  };
  metricHeaders: Array<{
    id: string;
  }>;
  rows: Array<{
    metricValues: number[];
    dimensionValue: string;
    dimensionItemId: string;
  }>;
}

export interface PieChartDataState {
  data: PieChartApiResponse | null;
  isLoading: boolean;
}

export interface PieChartState {
  [metricId: string]: PieChartDataState;
}

export interface KPIViewProductsState {
  data: PieChartApiResponse | null;
}

export interface FetchKPIProductsAction {
  type: typeof FETCH_KPI_PRODUCTS.REQUEST;
  payload: FetchKPIProductsPayload;
}

export interface FetchKPIProductsPayload {
  storeId: string;
  dateRange: {
    startDate: string;
    endDate: string;
  };
  limit?: number;
  selectedView: string;
  dimension: {
    id: string;
  };
  metrics: {
    id: string;
  }[];
  sortBy:
    | {
        metricId: string;
        desc: boolean;
      }
    | {
        metricId: string;
        desc: boolean;
      }[];
  isProductIdAnalyticIdAPIAvailable: boolean;
}

export interface KPIProductDetails {
  productId: string;
  code: string;
  analyticsId: string;
}

export const FETCH_ORDERS_BY_LOCATIONS = {
  REQUEST: "FETCH_ORDERS_BY_LOCATIONS_REQUEST",
  SUCCESS: "FETCH_ORDERS_BY_LOCATIONS_SUCCESS",
  FAILURE: "FETCH_ORDERS_BY_LOCATIONS_FAILURE",
};

export const RESET_LOCATION_TREE_STATE = "RESET_LOCATION_TREE_STATE";

export const FETCH_KPI_ANALYSIS = {
  REQUEST: "FETCH_KPI_ANALYSIS_REQUEST",
  SUCCESS: "FETCH_KPI_ANALYSIS_SUCCESS",
  FAILURE: "FETCH_KPI_ANALYSIS_FAILURE",
};

export type LocationDimension = string;

export interface LocationTreeNode {
  id: string;
  dimensionValue: string;
  dimensionItemId: string;
  metricValue: number;
  dimension: LocationDimension;
  children?: LocationTreeNode[];
  isLoading?: boolean;
  isExpanded?: boolean;
  hasChildren?: boolean;
  parentPath?: Array<{
    dimensionId: LocationDimension;
    dimensionItemId: string;
  }>;
}

export interface LocationTreeState {
  data: LocationTreeNode[];
  isLoading: boolean;
  expandedNodes: string[];
}

export interface FetchLocationTreeDataAction {
  type: typeof FETCH_ORDERS_BY_LOCATIONS.REQUEST;
  payload: FetchLocationTreeDataPayload;
}

export interface FetchLocationTreeDataPayload {
  storeId: string;
  dateRange: {
    startDate: string;
    endDate: string;
  };
  dimension: LocationDimension;
  dimensionBreakdown?: Array<{
    dimensionId: LocationDimension;
    dimensionItemId: string;
  }>;
  parentNodeId?: string;
  metricId?: string;
  limit?: number;
  sortBy?: {
    metricId: string;
    desc: boolean;
  };
}

export interface FetchLocationTreeDataSuccessAction {
  type: typeof FETCH_ORDERS_BY_LOCATIONS.SUCCESS;
  payload: {
    data: PieChartApiResponse;
    dimension: LocationDimension;
    parentNodeId?: string;
    parentPath?: Array<{
      dimensionId: LocationDimension;
      dimensionItemId: string;
    }>;
  };
}

export interface FetchLocationTreeDataFailureAction {
  type: typeof FETCH_ORDERS_BY_LOCATIONS.FAILURE;
  payload: {
    error: string;
    parentNodeId?: string;
  };
}

export interface ResetLocationTreeStateAction {
  type: typeof RESET_LOCATION_TREE_STATE;
}
export interface LocationTreeApiResponse {
  dimensionHeader: {
    id: string;
  };
  metricHeaders: Array<{
    id: string;
  }>;
  rows: Array<{
    dimensionValue: string;
    dimensionItemId: string;
    metricValues: number[];
  }>;
}

export interface LocationTreeCallApiSuccessAction {
  type: typeof FETCH_ORDERS_BY_LOCATIONS.SUCCESS;
  payload: {
    dimensionHeader: {
      id: string;
    };
    metricHeaders: Array<{
      id: string;
    }>;
    rows: Array<{
      dimensionValue: string;
      dimensionItemId: string;
      metricValues: number[];
    }>;
    storeId: string;
    dateRange?: {
      startDate: string;
      endDate: string;
    };
    dimension: {
      id: LocationDimension;
    };
    metrics: Array<{
      id: string;
    }>;
    sortBy: {
      metricId: string;
      desc: boolean;
    };
    limit: number;
    parentNodeId?: string;
    dimensionBreakdown?: Array<{
      dimensionId: LocationDimension;
      dimensionItemId: string;
    }>;
  };
}

export interface FetchKPIAnalysisPayload {
  storeId: string;
  date?: string; // Optional - defaults to current date in tenant timezone
}

export interface KPIAnalysisResponse {
  accountId: string;
  storeId: string;
  date: string;
  generatedAt: string;
  narrative: string;
}

export interface KPIAnalysisState {
  data: KPIAnalysisResponse | null;
  isLoading: boolean;
  retryAfter: number | null;
  is404Error: boolean;
  shouldDisableSummaryTab: boolean;
}

export interface DateYearMetricsApiResponse {
  dimensionHeader: {
    id: string;
  };
  metricHeaders: Array<{
    id: string;
  }>;
  rows: Array<{
    metricValues: number[];
    dimensionValue: string;
    dimensionItemId: string;
  }>;
}

export interface DateYearMetricsState {
  data: DateYearMetricsApiResponse | null;
  isLoading: boolean;
}

export interface FetchKPIAnalysisAction {
  type: typeof FETCH_KPI_ANALYSIS.REQUEST;
  payload: FetchKPIAnalysisPayload;
}

export interface FetchKPIAnalysisSuccessAction {
  type: typeof FETCH_KPI_ANALYSIS.SUCCESS;
  payload: KPIAnalysisResponse;
}

export interface FetchKPIAnalysisFailureAction {
  type: typeof FETCH_KPI_ANALYSIS.FAILURE;
  payload: {
    error: string;
    retryAfter?: number;
    is404Error?: boolean;
  };
}

export interface FetchDateYearMetricsSuccessAction {
  type: typeof FETCH_DATE_YEAR_METRICS.SUCCESS;
  payload: DateYearMetricsApiResponse;
}

export const LOAD_ANALYZER_SERVICE_URL = "LOAD_ANALYZER_SERVICE_URL";

export interface UpdateKPIProductsDetailsPayload {
  products: {
    productId: string;
    analyticsId: string;
  }[];
}

export interface UpdateKPIProductsDetailsAction {
  type: typeof UPDATE_KPI_PRODUCTS_DETAILS;
  payload: UpdateKPIProductsDetailsPayload;
}

export interface LoadKPIStoreListAction {
  type: typeof LOAD_KPI_STORE_LIST;
}

export interface KPIStore {
  storeId: string;
  storeName?: string;
  storeCode?: string;
}

export interface FetchKPIStoreListSuccessAction {
  type: typeof FETCH_KPI_STORE_LIST.SUCCESS;
  payload: {
    results: Array<{
      storeId: string;
      code: string;
      name: string;
    }>;
    count: number;
    total: number;
  };
}

export interface FetchKPIStoreListFailureAction {
  type: typeof FETCH_KPI_STORE_LIST.FAILURE;
  payload: {
    error: string;
  };
}

export interface KPIStoreListState {
  stores: KPIStore[];
  isLoading: boolean;
  isLoaded: boolean;
}
